/**
 * verificaInArchivio.js — quale codice fiscale il tablet chiede all'archivio,
 * e quante volte (Alex, 2 ottobre 2026).
 *
 * PERCHE' ESISTE
 * Il tablet ha cinque codici diversi l'ora per verificare se una persona
 * risulta gia' registrata (il freno contro chi passa in rassegna una lista:
 * CLAUDE.md, «Il tablet dice se un codice fiscale risulta gia' registrato»).
 * Il modulo chiedeva il codice a OGNI modifica del campo arrivato a sedici
 * caratteri, anche quando il codice tornava uguale. Il 2 ottobre dalle 13:22
 * un tablet ha chiesto lo stesso codice tre volte in tre secondi e un
 * secondo codice cinque volte in nove minuti: due persone, otto verifiche,
 * e le ultime tre rifiutate e trattate in silenzio come «non registrato».
 *
 * Due regole, una funzione ciascuna, provate da
 * frontend/scripts/provaVerificaCf.js:
 *   1. si chiede solo un codice fiscale italiano VALIDO - formato e carattere
 *      di controllo, con la funzione di sempre (validaCodiceFiscale): un
 *      codice sbagliato non passa comunque il primo passo del modulo, e
 *      chiederlo spende un tentativo per niente;
 *   2. lo stesso codice si chiede UNA volta sola in una compilazione: la
 *      seconda risposta e' la prima, presa dalla memoria, anche quando la
 *      prima era «non riesco a verificare». Mai due volte.
 */
import { validaCodiceFiscale } from './codiceFiscale';

/**
 * Vero se il tablet deve chiedere all'archivio questo codice: solo un codice
 * fiscale italiano col formato e il carattere di controllo giusti. Un
 * documento di un altro tipo (ISS di San Marino, estero) non si chiede.
 */
export function daChiedereAllArchivio(cf, tipo = 'cf_italiano') {
    if ((tipo || 'cf_italiano') !== 'cf_italiano') return false;
    return validaCodiceFiscale(cf).valido;
}

/**
 * Una memoria delle domande fatte in una compilazione. `chiedi(cf)` fa la
 * domanda vera e restituisce una Promise; quella che torna di qui la fa
 * una volta sola per codice, e alle volte dopo restituisce la stessa
 * Promise - anche mentre la prima e' ancora in viaggio, cosi' due modifiche
 * di fila sullo stesso codice non partono in due.
 * `chiedi` non deve rifiutare: ogni esito, anche l'errore, e' un esito.
 */
export function memoriaVerifiche(chiedi) {
    const fatte = new Map();
    return (cf) => {
        const codice = String(cf || '').toUpperCase();
        if (!fatte.has(codice)) fatte.set(codice, Promise.resolve().then(() => chiedi(codice)));
        return fatte.get(codice);
    };
}
